import React from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import html2pdf from "html2pdf.js";

export default function ComplianceViewModal({ data, visible, onHide }) {
    if (!data) return null;
    const reviewHtml = data?.html || "";

    /* ---------------- PDF DOWNLOAD ---------------- */

    const downloadPDF = () => {
        if (!reviewHtml) return;

        const container = document.createElement("div");

        container.style.width = "210mm"; // A4 width
        container.style.padding = "20mm";
        container.style.boxSizing = "border-box";
        container.style.background = "white";

        container.innerHTML = `
            <style>
                body { font-family: Arial, sans-serif; }
                img { max-width: 100%; }
                table { width: 100%; border-collapse: collapse; }
                tr, td, th { page-break-inside: avoid; }
                p { page-break-inside: avoid; }
            </style>
            ${reviewHtml}
        `;

        const opt = {
            margin: [10, 10, 10, 10],
            filename: `${data?.fileName || "document"}.pdf`,
            image: { type: "jpeg", quality: 1 },
            html2canvas: {
                scale: 3,
                useCORS: true,
                logging: false
            },
            jsPDF: {
                unit: "mm",
                format: "a4",
                orientation: "portrait"
            },
            pagebreak: {
                mode: ["avoid-all", "css", "legacy"]
            }
        };

        html2pdf().set(opt).from(container).save();
    };

    /* ---------------- DOC DOWNLOAD ---------------- */

    const downloadDOC = () => {
        if (!reviewHtml) return;

        const html = `
        <html xmlns:o='urn:schemas-microsoft-com:office:office'
        xmlns:w='urn:schemas-microsoft-com:office:word'
        xmlns='http://www.w3.org/TR/REC-html40'>
        <head>
            <meta charset='utf-8'>
            <style>
                body { font-family: Arial, sans-serif; }
                table { border-collapse: collapse; width: 100%; }
                img { max-width: 100%; }
            </style>
        </head>
        <body>
            ${reviewHtml}
        </body>
        </html>
        `;

        const blob = new Blob(["\ufeff", html], {
            type: "application/msword"
        });

        const url = URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = `${data?.fileName || "document"}.doc`;

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (<div>

        <Dialog
            header={data.fileName||"Review Content"}
            visible={visible}
            style={{ width: "75vw", maxWidth: "85vw" }}
            modal
            onHide={onHide}
            breakpoints={{ "960px": "95vw", "768px": "100vw" }}
        >
            {/* CONTENT AREA */}

            <div
                style={{
                    minHeight: "300px",
                    maxHeight: "65vh",
                    overflowY: "auto",
                    background: "#ffffff",
                    padding: "20px",
                    borderRadius: "6px",
                    border: "1px solid #eee",
                    marginTop: "1rem"
                }}
            >
                {reviewHtml ? (
                    <div dangerouslySetInnerHTML={{ __html: reviewHtml }} />
                ) : (
                    <div
                        className="d-flex justify-content-center align-items-center"
                        style={{ height: "200px", color: "#777" }}
                    >
                        <h5>No content available</h5>
                    </div>
                )}
            </div>

            {/* BUTTONS */}

            {reviewHtml && (
                <div
                    className="d-flex justify-content-end gap-3 mt-4"
                    style={{
                        borderTop: "1px solid #eee",
                        paddingTop: "15px"
                    }}
                >
                    <Button
                        icon="pi pi-file-pdf"
                        label="Download PDF"
                        className="downloadButtonsView p-button-sm p-button-danger"
                        onClick={downloadPDF}
                    />

                    <Button
                        icon="pi pi-file"
                        label="Download DOC"
                        className="downloadButtonsView p-button-sm p-button-success"
                        onClick={downloadDOC}
                    />
                </div>
            )}
        </Dialog>
        <style jsx>{`
        .downloadButtonsView.p-button {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            gap: 8px;

            padding: 8px 16px !important;
            min-width: 160px;

            white-space: nowrap;
        }

        .downloadButtonsView .p-button-icon {
            font-size: 14px;
        }

        .downloadButtonsView .p-button-label {
            white-space: nowrap;
            font-size: 14px;
        }
        `}</style>
    </div>
        
    );
}